export const promote = (config) => ({
    ...config
});
//# sourceMappingURL=parse-attachment-1-to-2.js.map